import React, { Component } from 'react';
import FormModal from 'components/shared/modal/FormModal';
import { connect } from 'react-redux';
import {
  getCreateQuoteForm,
  getCreateQuoteShow,
  getCreateQuoteState,
  getValidationMessage,
  getShowCounter,
} from 'selectors/admin/work-orders/details/create-quote';
import {
  closeCreateQuoteModal,
  continueWithFormRequest,
  editForm,
  createQuoteRequest,
  submitQuoteRequest,
  updateFormValue,
  respondCounterQuoteRequest,
} from 'actions/admin/work-orders/details/create-quote';
import DatetimePicker from 'components/shared/datetime-picker/DatetimePicker';
import Input from 'components/shared/input/Input';
import TextArea from 'components/shared/input/TextArea';
import './CreateQuoteModal.css';
import {
  getCurrentTask,
  getQuotes,
} from 'selectors/admin/work-orders/details/details';
import Number from 'components/shared/text/Number';
import Date from 'components/shared/text/Date';
import {
  getCurrentWorkOrder,
  getTasks,
} from 'selectors/admin/work-orders/work-orders';
import { getCurrentUser } from 'selectors/authentication';
import Button from 'components/shared/button/Button';
import Dropdown from 'components/shared/dropdown/Dropdown';
import moment from 'moment';
import ConfirmationPanel from 'components/shared/confirmation/ConfirmationPanel';
import checkCirclePng from 'images/check-circle.png';
import { goToWorkOrder } from 'actions/admin/work-orders/work-orders';
import { todayValidation } from 'services/utils/date-util';
import { usersUtil, TYPES } from 'services/utils/users-util';

/**
 * Create quote (for contractor)
 */
class CreateQuoteModal extends Component {
  constructor(props) {
    super(props);

    this.userIsAdmin =
      usersUtil.isAdmin(props.currentUser) ||
      usersUtil.hasType(props.currentUser, TYPES.GENERAL_CONTRACTOR);
    this.state = {
      successMessage: 'Quote has been submitted.',
    };
  }

  handleClose = (event) => {
    event.preventDefault();
    this.props.dispatch(closeCreateQuoteModal());
  };

  handleAttributeChange = (value, attribute) => {
    this.props.dispatch(updateFormValue(value, attribute));
  };

  handleContinue = () => {
    this.props.dispatch(
      continueWithFormRequest(
        this.props.form,
        this.props.currentTask.completionDate
      )
    );
  };

  handleQuoteEdit = (event) => {
    event.preventDefault();
    this.props.dispatch(editForm());
  };

  handleQuoteSubmit = (event) => {
    event.preventDefault();

    const taskQuote = this.props.quotes.find(
      (quote) =>
        quote.task.id === this.props.currentTask.id &&
        (!this.userIsAdmin || !quote.contractor_id)
    );
    if (taskQuote !== undefined) {
      this.props.dispatch(submitQuoteRequest(taskQuote.id, this.props.form));
    } else {
      this.props.dispatch(
        createQuoteRequest({
          ...this.props.form,
          taskId: { value: this.props.currentTask.id },
        })
      );
    }
  };

  handleQuoteRespondCounter = (action) => {
    const confirmed = window.confirm('Are you sure?');
    if (confirmed) {
      const taskQuote = this.props.quotes.find(
        (quote) => quote.task.id === this.props.currentTask.id
      );
      if (taskQuote !== undefined) {
        this.props.dispatch(respondCounterQuoteRequest(taskQuote.id, action));
      }
    }
  };

  handleQuoteAcceptCounter = (event) => {
    event.preventDefault();
    this.handleQuoteRespondCounter('accept');
    this.setState({
      successMessage: 'Counter offer acceptance has been submitted.',
    });
  };

  handleQuoteRejectCounter = (event) => {
    event.preventDefault();
    this.handleQuoteRespondCounter('reject');
    this.setState({
      successMessage: 'Counter offer rejection has been submitted.',
    });
  };

  handleQuoteRequestEnd = () => {
    this.props.dispatch(closeCreateQuoteModal());
    this.props.dispatch(goToWorkOrder(this.props.currentWorkOrder.id));
  };

  render() {
    return this.props.show ? (
      <FormModal
        className="create-quote-modal"
        show={this.props.show}
        showHeader={this.props.state !== 'confirmation'}
        title={this.props.state === 'edit' ? 'Create Quote' : 'Review Quote'}
        subTitle={
          <div>
            <span className="body-bold">Target Completion Date: </span>
            <span className="body-bold">
              <Date
                value={this.props.currentTask.completionDate}
                format="M/D/YYYY"
              />
            </span>
          </div>
        }
        onClose={this.handleClose}
      >
        <div>
          {
            {
              edit: this.getEditForm(),
              review: this.getReadOnlyForm(),
              confirmation: (
                <ConfirmationPanel
                  image={checkCirclePng}
                  firstLine="Success!"
                  lines={[this.state.successMessage]}
                  buttons={[
                    <Button
                      className="button-orange"
                      label="Continue"
                      onClick={this.handleQuoteRequestEnd}
                    />,
                  ]}
                />
              ),
            }[this.props.state]
          }
        </div>
      </FormModal>
    ) : null;
  }

  showDurationMessage() {
    // Add duration-1 because the start day counts as a working day
    const quoteCompletionDate = moment(this.props.form.startDate.value)
      .add(
        this.props.form.duration.value >= 1
          ? this.props.form.duration.value - 1
          : 0,
        'days'
      )
      .add(this.props.form.materialLeadDays.value, 'days');
    return quoteCompletionDate.isAfter(
      moment(this.props.currentTask.completionDate)
    );
  }

  renderDurationMessage() {
    if (this.showDurationMessage()) {
      return (
        <div className="duration-warning">
          Your date/duration does not meet the client's target completion date.
          Are you sure you would still like to submit?
        </div>
      );
    } else {
      return null;
    }
  }

  getReadOnlyForm() {
    const task = this.props.tasks.find(
      (element) => element.id === this.props.currentTask.id
    );
    return (
      <div className="create-quote-form">
        <div className="h2">{task.trade.label}</div>

        <table>
          <tbody>
            <tr>
              <td>Target Completion Date</td>
              <td>
                <Date value={task.completion_date} format="M/D/YYYY" />
              </td>
            </tr>

            <tr>
              <td>Duration in days</td>
              <td>{this.props.form.duration.value}</td>
            </tr>

            {this.props.form.materialLeadDays.value !== '' && (
              <tr>
                <td>Material Lead Time in days</td>
                <td>
                  <Number
                    value={this.props.form.materialLeadDays.value}
                    format="0.[0]"
                  />
                </td>
              </tr>
            )}

            <tr>
              <td>Cost</td>
              <td>
                <Number value={this.props.form.cost.value} format="$0,0" />
              </td>
            </tr>

            <tr>
              <td>Start Date</td>
              <td>
                <Date
                  value={this.props.form.startDate.value}
                  format="M/D/YYYY"
                />
              </td>
            </tr>

            {this.props.form.description.value !== '' && (
              <tr>
                <td>Description/Qualifications</td>
                <td>{this.props.form.description.value}</td>
              </tr>
            )}
            {this.showDurationMessage() && (
              <tr>
                <td colSpan={2} className="duration-warning-container">
                  {this.renderDurationMessage()}
                </td>
              </tr>
            )}

            {this.props.validationMessage !== null && (
              <tr>
                <td colSpan={2} className="invalid-message">
                  <div className="invalid-message">
                    {this.props.validationMessage}
                  </div>
                </td>
              </tr>
            )}

            <tr>
              <td />
              <td>
                {this.props.showCounter ? (
                  <input
                    className="btn button button-orange"
                    value="Accept Counter"
                    type="button"
                    onClick={this.handleQuoteAcceptCounter}
                  />
                ) : (
                  <input
                    className="btn button button-orange"
                    value="Submit Quote"
                    type="button"
                    onClick={this.handleQuoteSubmit}
                  />
                )}
                <input
                  className="btn button button-gray"
                  value="Edit Quote"
                  type="button"
                  onClick={this.handleQuoteEdit}
                />
                {this.props.showCounter && (
                  <input
                    className="btn button button-white"
                    value="Reject Counter"
                    type="button"
                    onClick={this.handleQuoteRejectCounter}
                  />
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  getEditForm() {
    const completionDateMoment = moment(this.props.currentTask.completionDate);

    return (
      <React.Fragment>
        <table className="create-quote-table">
          <tbody>
            <tr>
              <td>When can you get started?</td>
              <td>
                <DatetimePicker
                  isValidDate={(date) =>
                    todayValidation(date) &&
                    date.isSameOrBefore(completionDateMoment)
                  }
                  placeholder="Start date"
                  valid={this.props.form.startDate.valid}
                  value={this.props.form.startDate.value}
                  onChange={(value) =>
                    this.handleAttributeChange(value, 'startDate')
                  }
                />
              </td>
            </tr>

            <tr>
              <td>How long will it take?</td>
              <td>
                <Dropdown
                  options={CreateQuoteModal.createDurationOptions()}
                  placeholder="Duration in days"
                  valid={this.props.form.duration.valid}
                  value={this.props.form.duration.value}
                  onChange={(option) =>
                    this.handleAttributeChange(option.value, 'duration')
                  }
                />
              </td>
            </tr>

            <tr>
              <td>Material Lead Time</td>
              <td>
                <Dropdown
                  options={CreateQuoteModal.createMaterialLeadDaysOptions()}
                  clearable={true}
                  placeholder="Material Lead Time in days"
                  valid={this.props.form.materialLeadDays.valid}
                  value={this.props.form.materialLeadDays.value}
                  onChange={(option) =>
                    this.handleAttributeChange(
                      option ? option.value : '',
                      'materialLeadDays'
                    )
                  }
                />
              </td>
            </tr>

            <tr>
              <td>Total Cost</td>
              <td>
                <Input
                  placeholder="Total Cost"
                  type="number"
                  valid={this.props.form.cost.valid}
                  value={this.props.form.cost.value}
                  onChange={(value) =>
                    this.handleAttributeChange(value, 'cost')
                  }
                />
              </td>
            </tr>

            <tr>
              <td>Description/Qualifications</td>
              <td>
                <TextArea
                  placeholder="Is there anything the Spackle team should know regarding your quote, process or experience? (Please be sure to include any exclusions)."
                  value={this.props.form.description.value}
                  onChange={(value) =>
                    this.handleAttributeChange(value, 'description')
                  }
                />
              </td>
            </tr>
          </tbody>
        </table>

        {this.props.validationMessage !== null && (
          <div className="invalid-message">{this.props.validationMessage}</div>
        )}

        {this.showDurationMessage() && this.renderDurationMessage()}

        <Button
          className="button-orange"
          label="Continue"
          onClick={this.handleContinue}
        />
      </React.Fragment>
    );
  }

  static createDurationOptions() {
    const result = [];
    for (let i = 0.5; i <= 15; i = i + 0.5) {
      result.push({
        label: i + (i < 1.5 ? ' day' : ' days'),
        value: i,
      });
    }
    return result;
  }

  static createMaterialLeadDaysOptions() {
    const result = [];
    for (let i = 1; i <= 100; i = i + 1) {
      result.push({
        label: i + (i < 2 ? ' day' : ' days'),
        value: i,
      });
    }
    return result;
  }
}

export default connect((state) => {
  return {
    currentWorkOrder: getCurrentWorkOrder(state),
    currentTask: getCurrentTask(state),
    form: getCreateQuoteForm(state),
    quotes: getQuotes(state),
    show: getCreateQuoteShow(state),
    state: getCreateQuoteState(state),
    tasks: getTasks(state),
    validationMessage: getValidationMessage(state),
    showCounter: getShowCounter(state),
    currentUser: getCurrentUser(state),
  };
})(CreateQuoteModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/quotes/CreateQuoteModal.js